function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Nuevo-portal",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "Xl/Portal-Asociado-Menu",
  transform: "translate(-290.000000, -722.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "UI-icon/cam-doctor/outline/Naranja-Copy-2",
  transform: "translate(290.000000, 722.000000)"
}, /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle-4",
  stroke: "#EB5F0A",
  x: 2.5,
  y: 5.5,
  width: 23,
  height: 18,
  rx: 3
}), /*#__PURE__*/React.createElement("line", {
  x1: 5,
  y1: 9,
  x2: 14.0540981,
  y2: 17,
  id: "Path-2",
  stroke: "#EB5F0A",
  strokeLinecap: "round"
}), /*#__PURE__*/React.createElement("line", {
  x1: 14,
  y1: 9,
  x2: 23.0540981,
  y2: 17,
  id: "Path-2",
  stroke: "#EB5F0A",
  strokeLinecap: "round",
  transform: "translate(18.527049, 13.000000) scale(-1, 1) translate(-18.527049, -13.000000) "
}), /*#__PURE__*/React.createElement("line", {
  x1: 4.97930969,
  y1: 21.0206903,
  x2: 11.0311289,
  y2: 14.9688711,
  id: "Path-2",
  stroke: "#EB5F0A",
  strokeLinecap: "round"
}), /*#__PURE__*/React.createElement("line", {
  x1: 16.9793097,
  y1: 21.0206903,
  x2: 23.0311289,
  y2: 14.9688711,
  id: "Path-2",
  stroke: "#EB5F0A",
  strokeLinecap: "round",
  transform: "translate(20.000000, 18.000000) scale(-1, 1) translate(-20.000000, -18.000000) "
}), /*#__PURE__*/React.createElement("rect", {
  id: "Bounds",
  x: 0,
  y: 0,
  width: 28,
  height: 28
}))));

function SvgIconConsulta(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "28px",
    height: "28px",
    viewBox: "0 0 28 28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "6A28E968-EDBE-4E3D-B517-FB5F7416964C") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconConsulta);
export default __webpack_public_path__ + "static/media/icon_consulta.8d6a0434.svg";
export { ForwardRef as ReactComponent };